import { paths } from '../routes';

// paths.DASHBOARD_URL_PATH === location.pathname

const isActiveRoute = (path: string): string => {
  if (
    path === 'dashboard' &&
    paths.DASHBOARD_URL_PATH === window.location.pathname
  ) {
    return 'active';
  }

  if (
    path === 'pos-teller' &&
    paths.POS_TELLER_URL_PATH === window.location.pathname
  ) {
    return 'active';
  }

  if (
    path === 'inventory' &&
    [
      paths.INVENTORIES_URL_PATH,
      paths.ADD_MISC_URL_PATH.replace(':miscId', 'inventory'),
    ].includes(window.location.pathname)
  ) {
    return 'active';
  }

  if (
    path === 'preferences' &&
    ([
      paths.USERS_URL_PATH,
      paths.CUSTOMERS_URL_PATH,
      paths.SUPPLIERS_URL_PATH,
      paths.CASH_REGISTER_TELLER_URL_PATH,
    ].includes(window.location.pathname) ||
      window.location.pathname.includes('/accounts/'))
  ) {
    return 'active';
  }

  if (
    path === 'suppliers' &&
    paths.SUPPLIERS_URL_PATH === window.location.pathname
  ) {
    return 'active';
  }

  if (
    path === 'customers' &&
    paths.CUSTOMERS_URL_PATH === window.location.pathname
  ) {
    return 'active';
  }

  if (path === 'users' && paths.USERS_URL_PATH === window.location.pathname) {
    return 'active';
  }

  if (
    path === 'registers' &&
    paths.CASH_REGISTER_TELLER_URL_PATH === window.location.pathname
  ) {
    return 'active';
  }

  if (
    path === 'account-settings' &&
    [
      '/accounts/general',
      '/accounts/billing',
      '/accounts/registers',
      '/accounts/user-roles',
      '/accounts/taxes',
    ].includes(window.location.pathname)
  ) {
    return 'active';
  }

  return '';
};

export default isActiveRoute;
